import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import LogoCPro from 'assets/logos/logoCPro.svg';
import LogoCProShirt from 'assets/logos/logoCProShirt.svg';
import LogoSherpass from 'assets/logos/logoSherpass.svg';

import { useTranslation } from 'react-i18next';

import { Box, List, Drawer, SvgIcon, SxProps, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';

import { FEATURES_FLAG_KEYS } from '@/features/featuresFlag/apis/featureFlag.keys';
import { useFeaturesFlagState } from '@/features/featuresFlag/hooks';
import { LogOutIcon } from '@/utils/iconSVG';

import {
  stylesLogo,
  stylesNavDrawer,
  stylesDrawerLinks,
  stylesLogoWrapper,
  stylesNavigationIcon,
  stylesNavigationItem,
  stylesNavigationLogout,
  stylesNavigationIconSVG,
  stylesNavigationItemText,
} from './NavigationDrawer.styles';

type NavigationDrawerProps = {
  onHoverSideBarDrawer: () => void;
  isSideBarDrawerOpen: boolean;
};

export const NavigationDrawerWithOnlyLogout: React.FunctionComponent<NavigationDrawerProps> = ({
  isSideBarDrawerOpen,
  onHoverSideBarDrawer,
}) => {
  const { instance } = useMsal();
  const { t } = useTranslation('layouts');
  const isAuthenticated = useIsAuthenticated();

  const { featuresFlag } = useFeaturesFlagState();

  const isSherpass = featuresFlag.get(FEATURES_FLAG_KEYS.SHERPASS);
  const handleLogout = () => {
    if (isAuthenticated) {
      instance
        .logout({
          postLogoutRedirectUri: process.env.AZURE_FRONT_POST_LOGOUT_REDIRECT_URI,
        })
        .catch((error) => {
          // TODO Elhoucine Toaster
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  };

  return (
    <Drawer
      variant='permanent'
      open={isSideBarDrawerOpen}
      onMouseEnter={onHoverSideBarDrawer}
      onMouseLeave={onHoverSideBarDrawer}
      sx={stylesNavDrawer({ isOpen: isSideBarDrawerOpen, isSherpass }) as SxProps}
    >
      <Box sx={stylesDrawerLinks}>
        <Box sx={stylesLogoWrapper(isSideBarDrawerOpen)}>
          {isSherpass ? (
            <Box component='img' alt='Sharepass' src={isSideBarDrawerOpen ? LogoCPro : LogoCProShirt} sx={stylesLogo} />
          ) : (
            <Box component='img' alt='Sharepass' src={LogoSherpass} sx={stylesLogo} />
          )}
        </Box>

        <List component='nav' aria-labelledby='nested-list-subheader' sx={stylesNavigationLogout}>
          <ListItemButton sx={stylesNavigationItem} onClick={handleLogout}>
            <ListItemIcon sx={stylesNavigationIcon}>
              <SvgIcon component={LogOutIcon} sx={stylesNavigationIconSVG} />
            </ListItemIcon>
            <ListItemText primary={t('drawer.logout')} sx={stylesNavigationItemText(isSideBarDrawerOpen)} />
          </ListItemButton>
        </List>
      </Box>
    </Drawer>
  );
};
